import React, { useEffect } from 'react';

import { l10n } from '@ott/l10n';
import Modal from '@ott/modal';
import metrics from '@ott/utility-km';

import styles from './MetaWebBanner.scss';

type MetaWebBannerProps = {
  isOpen: boolean;
  onIsOpenChange: (isOpen: boolean) => void;
  metricParams?: Record<string, unknown>;
};

const MetaWebBanner = (props: MetaWebBannerProps) => {
  const { isOpen, onIsOpenChange, metricParams = {} } = props;

  useEffect(() => {
    if (isOpen) {
      metrics('meta-web-banner-show', { obj: metricParams });
    }

    return () => {
      metrics('meta-web-banner-close-swipe', { obj: metricParams });
    };
  }, [isOpen]);

  const handleButtonProceedClick = () => {
    window.open('https://12trip.onelink.me/JIYP/czb4b55f', '_blank');

    metrics('meta-web-banner-download-click', { obj: metricParams });
  };

  const handleButtonCloseClick = () => {
    onIsOpenChange(false);

    metrics('meta-web-banner-close-click', { obj: metricParams });
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={handleButtonCloseClick}
      contentOptions={{
        childrenClassNames: {
          title: styles.title,
        },
      }}
      bottomSheetOnMobile={true}
      fullScreenOnMobile={false}
    >
      {{
        icon: (
          <img
            src="https://static.onetwotrip.com/images/index/meta-web-curtain/meta_web_curtain_logo.svg"
            alt=""
          />
        ),
        title: l10n('metaWebBanner.title'),
        primaryButton: {
          text: l10n('metaWebBanner.primaryButton.text'),
          onClick: handleButtonProceedClick,
        },
      }}
    </Modal>
  );
};

export { MetaWebBanner };
